module.exports = __webpack_public_path__ + "static/media/deep-navy.75712cbd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/apple-watch/silver-aluminum-case/deep-navy.jpeg
// module id = 2048
// module chunks = 0